import { Box } from '@mui/material';
import DelayedRender from 'components/delayed-render/delayed-render.component';
import Spinner from 'components/spinner/spinner.component';
import { useMapType } from 'hooks/maps.hooks';
import LocationsMapMapbox from '../locations-map-mapbox/locations-map-mapbox.component';
import LocationsMap from './locations-map.component';

const LocationsMapGate = ({ selectedStore, ...rest }) => {
  const { isMapbox, isLoading } = useMapType();

  if (isLoading) {
    return (
      <Box flexGrow={1} order={2}>
        <Spinner />
      </Box>
    );
  }

  if (isMapbox) {
    return (
      <Box flexGrow={1} order={2} data-testid="LocationsMap.Container">
        <DelayedRender>
          <LocationsMapMapbox selectedStore={selectedStore} {...rest} />
        </DelayedRender>
      </Box>
    );
  }
  return <LocationsMap {...rest} />;
};
export default LocationsMapGate;
